// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"56524ed6","977":"33fbf2a5"}[chunkId] + ".chunk.js";
};